// Partner organizations data
export const partnersData = [
  { id: 1, name: "Partner 1", logo: "/partners/partner1.png" },
  { id: 2, name: "Partner 2", logo: "/partners/partner2.png" },
  { id: 3, name: "Partner 3", logo: "/partners/partner3.jpg" },
  { id: 4, name: "Partner 4", logo: "/partners/partner4.jpg" },
  { id: 5, name: "Partner 5", logo: "/partners/partner5.png" },
  { id: 6, name: "Partner 6", logo: "/partners/partner6.jpg" },
  { id: 7, name: "Partner 7", logo: "/partners/partner7.jpg" },
  { id: 8, name: "Partner 8", logo: "/partners/partner8.png" },
  { id: 9, name: "Partner 9", logo: "/partners/partner9.jpg" },
  { id: 10, name: "Partner 10", logo: "/partners/partner10.png" },
  { id: 11, name: "Partner 11", logo: "/partners/partner11.jpeg" },
  { id: 12, name: "Partner 12", logo: "/partners/partner12.jpg" },
  { id: 13, name: "Partner 13", logo: "/partners/partner13.png" },
  { id: 14, name: "Partner 14", logo: "/partners/partner14.png" },
  { id: 15, name: "Partner 15", logo: "/partners/partner15.jpg" },
  { id: 16, name: "Partner 16", logo: "/partners/partner16.png" },
  { id: 17, name: "Partner 17", logo: "/partners/partner17.png" },
  { id: 18, name: "Partner 18", logo: "/partners/partner18.png" },
  { id: 19, name: "Partner 19", logo: "/partners/partner19.jpg" },
  { id: 20, name: "Partner 20", logo: "/partners/partner20.avif" },
  { id: 21, name: "Partner 21", logo: "/partners/partner21.jpg" },
  { id: 22, name: "Partner 22", logo: "/partners/partner22.png" },
  { id: 23, name: "Partner 23", logo: "/partners/partner23.png" },
  { id: 24, name: "Partner 24", logo: "/partners/partner24.png" },
  { id: 25, name: "Partner 25", logo: "/partners/partner25.png" },
  { id: 26, name: "Partner 26", logo: "/partners/partner26.jpg" },
  { id: 27, name: "Partner 27", logo: "/partners/partner27.png" },
  { id: 28, name: "Partner 28", logo: "/partners/partner28.png" }
];

